import styled from "styled-components";
import { IMAGES } from "../../../../constants/images";

export default function Controls({ toggleDrawMode, drawMode, clear, calculatedHandler }) {
  return (
    <ControlsContainer>
      <button onClick={toggleDrawMode} className={drawMode.area === "draw_line_string" ? "active" : ""}>
        {drawMode.area === "simple_select" ? "Enable" : "Disable"} Draw Mode <img className="button-img" src={IMAGES.LINE} alt="line" />
      </button>
      <button onClick={clear}>
        Clear <img className="button-img" src={IMAGES.BIN} alt="bin" />
      </button>
      <button onClick={() => calculatedHandler(true)} className="satellite-controls-button">
        Calculate <img className="button-img" src={IMAGES.CALCULATE} alt="calculator" />
      </button>
    </ControlsContainer>
  );
}

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  backdrop-filter: blur(8px);
  background: rgb(238 238 238 / 70%);
  border: 1px solid #f6f8fb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 4px rgb(50 50 71 / 8%), 0 4px 8px rgb(50 50 71 / 6%);
  align-items: center;
  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    padding: 7px;
    outline: none;
    cursor: pointer;
    background-color: #f4f4f4;
    border: 0.5px solid #dcdcdc;
    box-shadow: 0 4px 4px rgb(50 50 71 / 8%), 0 4px 8px rgb(50 50 71 / 6%);
    transition: background-color 0.2s linear;
    width: 200px;

    img {
      width: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &:hover:not(.active) {
      background-color: #fff;
    }

    &.active {
      background-color: #007bff;
      color: #fff;

      &:hover {
        background-color: #268fff;
      }
    }
  }
`;
